'use client';
import { BrowserRouter, matchPath, Navigate, Route, Routes } from 'react-router-dom';
import styles from './panel.module.scss';
import PanelMenuComp from './panelMenu/panelMenu.index';
import { useBP } from 'scripts';
import { PATH } from 'data';
import PostFormComp from './postForm/addPost.index';
import MyAdsComp from './myAds/myAds.index';
import MyAdsDetailComp from './myAdsDetail/myAdsDetail.index';
import PreviewComp from './preview/preview.index';
import NewTicketComp from './newTicket/newTicket.index';
import ChatComp from './chat/chat.index';
import { __PanelNoMenuRoutes } from './panel.data';
import { useContext, useState } from 'react';
import { Spin } from 'antd';
import { usePathname } from 'next/navigation';
import TicketComp from './tickets/tickets.index';
import MyViewedComp from './myViews/myViews.index';
import MyBookmarkComp from './myBookmarks/myBookmarks.index';
import { GlobalContext } from 'context';

function PanelComp() {
    const bp = useBP();
    const [loading, setLoading] = useState(false);
    const pathname = usePathname();
    const { categories } = useContext(GlobalContext);
    const hideMenu = __PanelNoMenuRoutes.map((i) => !!matchPath({ path: i, end: false }, pathname)).includes(true);
    const mainRoute = (p: string) => {
        const newP = p.length && p.startsWith('/') ? p.slice(1) : p;
        return newP + '/*';
    };
    const keygen = (p: string) => {
        const splitted = p.split('/');
        return splitted[splitted.length - 1];
    };
    const routeGen = (p: string) => {
        const splitted = p.split('/');
        return splitted[splitted.length - 1] + '/*';
    };

    if (loading)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );

    return (
        <BrowserRouter>
            <div className={`${styles['profile-layout']} d-flex g-4`}>
                {hideMenu ? null : (
                    <div className={`${styles['menu-layout']} flex-1 d-pre-lg-none`}>
                        <PanelMenuComp onLogout={() => setLoading(true)} />
                    </div>
                )}
                <div className={`${styles['content-layout']} flex-1 ${hideMenu ? styles['full-width'] : ''}`}>
                    <Routes>
                        <Route path={mainRoute(PATH.panel.index)}>
                            <Route path={keygen(PATH.panel.myAds.index())}>
                                <Route path={keygen(PATH.panel.myAds.detail())}>
                                    <Route
                                        path={routeGen(PATH.panel.myAds.preview())}
                                        element={<PreviewComp categories={categories} />}
                                    />
                                    <Route path={routeGen(PATH.panel.myAds.edit())} element={<PostFormComp />} />
                                    <Route index element={<MyAdsDetailComp />} />
                                </Route>
                                <Route index element={<MyAdsComp />} />
                            </Route>
                            <Route path={keygen(PATH.panel.tickets.index())}>
                                <Route path={routeGen(PATH.panel.tickets.new())} element={<NewTicketComp />} />
                                <Route index element={<TicketComp />} />
                            </Route>
                            <Route path={routeGen(PATH.panel.chat())} element={<ChatComp />} />
                            <Route path={routeGen(PATH.panel.addPost.index())} element={<PostFormComp />} />
                            <Route path={routeGen(PATH.panel.views())} element={<MyViewedComp />} />
                            <Route path={routeGen(PATH.panel.bookmarks())} element={<MyBookmarkComp />} />
                            <Route
                                path={routeGen(PATH.panel.mobileMenu())}
                                element={<PanelMenuComp onLogout={() => setLoading(true)} />}
                            />
                            {bp ? (
                                <Route
                                    path={'*'}
                                    element={
                                        <Navigate
                                            to={bp.MD_LTE ? PATH.panel.mobileMenu() : PATH.panel.myAds.index()}
                                            replace
                                        />
                                    }
                                />
                            ) : null}
                        </Route>
                    </Routes>
                </div>
            </div>
        </BrowserRouter>
    );
}

export default PanelComp;
